module.exports = __webpack_public_path__ + "static/img/img-ativar-tag-2026.93fd432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-ativar-tag-2026.png
// module id = 1777
// module chunks = 1